import React, { Component } from 'react';
import {connect} from "react-redux";
import {startedTransactionImport} from "../../redux/actions";
import Toolbar from "../reusables/Toolbar";
import DynamicExcelTools from "../reusables/DynamicExcelTools";
import PrivateCoreService from "../../services/PrivateCoreService";

class TransactionOverview extends Component {
    constructor(props) {
        super(props);
        this.customerId = props.match.params.id;
        this.state = { };
    }

    postSingle(data, query, callback) {
        let customer = this.props.currentCustomer;
        let jwt = this.props.privateCoreJwt[this.customerId];
        let service = new PrivateCoreService(this.props.dispatch);

        data['transactionSource'] = process.env.REACT_APP_TRANSACTION_IMPORT_SOURCE ? process.env.REACT_APP_TRANSACTION_IMPORT_SOURCE : 'OFFICIAL';

        service.postTransaction(customer, jwt, data, query, callback)
    }

    render() {
        return (
            <div>
                <Toolbar>
                    <DynamicExcelTools fileName="transactions" subject="transaction"
                                       startImportAction={startedTransactionImport()}
                                       purgeEmptyAttributes={true}
                                       postSingleEntry={ (entry, query, callback) => this.postSingle(entry, query, callback)}
                                       requiredColumns={['transactionReference', 'transactionType']}/>
                </Toolbar>
            </div>
        );
    }
}

const mapStateToProps = ({
    currentCustomer,
    privateCoreJwt
}) => ({
    currentCustomer,
    privateCoreJwt
});

const mapDispatchToProps = (dispatch) => ({dispatch});

export default connect(mapStateToProps, mapDispatchToProps)(TransactionOverview);


// WEBPACK FOOTER //
// ./src/components/transactions/TransactionOverview.js